<template>
  <v-alert dark :border="settings.border" :color="settings.color">
    <v-avatar v-if="message.author.avatar" slot="append">
      <img :src="message.author.avatar" :alt="displayName" />
    </v-avatar>
    {{ displayName }}<br />
    <span dark class="white--text caption">{{
      message.createdDate | formatDate
    }}</span
    ><br />
    {{ message.content }}
  </v-alert>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    initials() {
      if (this.message.author.firstName && this.message.author.lastName) {
        return (
          this.message.author.firstName.charAt(0) +
          "" +
          this.message.author.lastName.charAt(0)
        );
      } else {
        return "NA";
      }
    },
    displayName() {
      return `${this.message?.author?.firstName} ${this.message?.author?.lastName}`;
    },
    settings() {
      //If auth user is equal to author user
      const isCurrentUser =
        this.$store.state.auth.user.id === this.message.author.id;
      return isCurrentUser
        ? { border: "right", color: "indigo" }
        : { border: "left", color: "green darken-3" };
    }
  }
};
</script>

<style></style>
